import { Activity, AlertOctagon, Hash, Timer } from "lucide-react";

const ENGAGEMENT = {
  engaged: ["Seems engaged", "text-emerald-500"],
  neutral: ["Seems neutral", "text-sky-500"],
  uncomfortable: ["May be uncomfortable", "text-amber-500"],
  uninterested: ["May not be interested", "text-rose-500"],
  unclear: ["Hard to tell", "text-muted-foreground"],
};

export const AnalysisCard = ({ analysis, latency }) => {
  const [label, color] = ENGAGEMENT[analysis.engagement] || ENGAGEMENT.unclear;
  return (
    <div className="panel p-5 space-y-4" data-testid="ai-analysis-card">
      {analysis.boundary_detected && (
        <div data-testid="boundary-alert" className="flex gap-2 rounded-xl border border-rose-500/40 bg-rose-500/10 p-3 text-sm">
          <AlertOctagon className="h-4 w-4 text-rose-500 shrink-0 mt-0.5" />
          <span>It looks like they've set a boundary. These suggestions are respectful acknowledgments rather than flirting — please respect their answer.</span>
        </div>
      )}
      <div className="grid grid-cols-3 gap-3 text-sm">
        <div><div className="text-[11px] uppercase tracking-wider text-muted-foreground mb-1 flex items-center gap-1"><Activity className="h-3 w-3" />Tone</div><div className="font-semibold capitalize" data-testid="analysis-tone">{analysis.tone}</div></div>
        <div><div className="text-[11px] uppercase tracking-wider text-muted-foreground mb-1 flex items-center gap-1"><Hash className="h-3 w-3" />Topic</div><div className="font-semibold truncate" data-testid="analysis-topic">{analysis.topic || "—"}</div></div>
        <div><div className="text-[11px] uppercase tracking-wider text-muted-foreground mb-1">Their vibe</div><div className={`font-semibold ${color}`} data-testid="analysis-engagement">{label}</div></div>
      </div>
      {analysis.engagement_note && <p className="text-xs text-muted-foreground" data-testid="analysis-note">{analysis.engagement_note} This is a guess from a short text sample, not a read on their feelings.</p>}
      {latency != null && <div className="text-[11px] text-muted-foreground flex items-center gap-1" data-testid="analysis-latency"><Timer className="h-3 w-3" />Generated in {(latency / 1000).toFixed(1)}s</div>}
    </div>
  );
};
